// TODO move shared types from Customer to shared
import Status from '../Customer/Status'
import TelecomsAddress from '../shared/Address/TelecomsAddress'

export class Contractor {
  public id: string = ''
  public name: string = ''
  public statuses: Status[] = []
  public identifiers: {
    sitesIdentifiers: string[]
    parentIdentifier?: string
  } = {
      sitesIdentifiers: [],
      parentIdentifier: '',
    }
  public addresses: {
    telecomsAddresses: TelecomsAddress[]
  } = {
      telecomsAddresses: [],
    }
}

export class ContractorPriority {
  public isWorkingHour: string = ''
  public isHoliday: boolean = false
  public repairPriority: string = ''
}
export enum catalystTriageContractorType {
  CATALYST_TRIAGE_DEFECT = 'CATALYST_TRIAGE_DEFECT',
  CATALYST_TRIAGE_TIER2 = 'CATALYST_TRIAGE_TIER2',
  CATALYST_TRIAGE_EMA = 'CATALYST_TRIAGE_EMA',
}

export enum EMAContractorType {
  EMA_UNKNOWN_CONTACTDETAILS_TRIAGE = 'EMA_UNKNOWN_CONTACTDETAILS_TRIAGE',
  UNKNOWN_EMA_TRIAGE = 'UNKNOWN_EMA_TRIAGE'
}

export class DmcAssessmentPriority {
  public adjustedRiskRating: string = ''
  public totalScore: number = 0
  public riskRating: string = ''
  public vulnerabilityScore: number = 0
  public vulnerabilityRiskRating: string = ''
}